// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newOrderGoodsAdd {\n  height: 600px;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n}\n.newOrderGoodsAdd .el-tabs__item {\n  padding: 0 10px;\n}\n.newOrderGoodsAdd .el-tabs__item.is-active {\n  text-decoration: underline;\n}\n.newOrderGoodsAdd .el-popper[x-placement^=bottom] {\n  margin-left: -40px;\n}", ""]);
// Exports
module.exports = exports;
